<script setup lang="ts">
import TransitionFadeRouterView from '@/components/router/TransitionFadeRouterView.vue'
import Presentation from '@/components/common/Presentation.vue'
import { removeBodyPrefixClasses } from '@/utils/helpers'

removeBodyPrefixClasses('part-')
document.body.classList.add('part-intro')
</script>

<template>
  <Presentation desktop="bg-intro-desktop.mp4" mobile="bg-intro-mobile.mp4">
    <TransitionFadeRouterView />
  </Presentation>
</template>
